import { ReactComponent as ArrowRight } from '@assets/icons/arrow_right.svg';
import { ReactComponent as Cancel } from '@assets/icons/cancel.svg';
import { ReactComponent as Check } from '@assets/icons/check.svg';
import { ReactComponent as Plus } from '@assets/icons/plus.svg';
import { ReactComponent as Power } from '@assets/icons/power.svg';
import { SerializedStyles } from '@emotion/react';
import {
  useFocusable,
  UseFocusableConfig
} from '@noriginmedia/norigin-spatial-navigation';
import { FC, PropsWithChildren, useMemo } from 'react';

import * as styles from './styles';

export type IconType = 'plus' | 'check' | 'cancel' | 'arrow' | 'power';

interface FocusableIconButtonProps extends UseFocusableConfig, PropsWithChildren {
  iconType: IconType;
  buttonStyle?: SerializedStyles;
  focusedStyle?: SerializedStyles;
  iconStyle?: SerializedStyles;
  iconFocusedStyle?: SerializedStyles;
  forceFocused?: boolean;
}

const FocusableIconButton: FC<FocusableIconButtonProps> = (props) => {
  const { iconType, buttonStyle, focusedStyle, iconStyle, iconFocusedStyle, children, forceFocused = false } =
    props;
  const { ref, focused } = useFocusable({ ...props });

  const Icon = useMemo(() => {
    switch (iconType) {
      case 'check':
        return Check;
      case 'plus':
        return Plus;
      case 'cancel':
        return Cancel;
      case 'arrow':
        return ArrowRight;
      case 'power':
        return Power;
      default:
        return Check;
    }
  }, [iconType]);

  return (
    <div
      ref={ref}
      css={[
        styles.button,
        buttonStyle,
        ...(forceFocused || focused ? [styles.focusedButton, focusedStyle] : [])
      ]}
    >
      {children}
      <Icon
        css={[
          styles.icon,
          iconStyle,
          ...(forceFocused || focused ? [styles.focusedIcon, iconFocusedStyle] : [])
        ]}
      />
    </div>
  );
};

export default FocusableIconButton;
